import { render, staticRenderFns } from "./tab-text-inputs.vue?vue&type=template&id=1c122674"
import script from "./tab-text-inputs.vue?vue&type=script&lang=js"
export * from "./tab-text-inputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports